import * as React from "react";

import { ColorPrimary } from "./theme";

export const InfoIcon = ({
  fill,
  width,
  height,
}: {
  fill?: string;
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      width={width || "16"}
      height={height || "16"}
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_10675_44714)">
        <path
          d="M17 0C7.60411 0 0 7.60325 0 17C0 26.3958 7.60325 34 17 34C26.3959 34 34 26.3967 34 17C34 7.60425 26.3967 0 17 0ZM18.7458 23.7483C18.7458 24.2854 17.9626 24.8223 17.0003 24.8223C15.9933 24.8223 15.2774 24.2854 15.2774 23.7483V15.2226C15.2774 14.596 15.9934 14.1708 17.0003 14.1708C17.9626 14.1708 18.7458 14.596 18.7458 15.2226V23.7483ZM17.0004 12.1122C15.971 12.1122 15.1655 11.3514 15.1655 10.501C15.1655 9.65069 15.9711 8.91225 17.0004 8.91225C18.0074 8.91225 18.813 9.65069 18.813 10.501C18.813 11.3514 18.0073 12.1122 17.0004 12.1122Z"
          fill={fill || ColorPrimary.main}
        />
      </g>
      <defs>
        <clipPath id="clip0_10675_44714">
          <rect width="34" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
